export const RoleType = {
    'SUBJECT': 'subject',
    'PREDICATE': 'predicate',
    'OBJECT': 'object',
    'CONTEXT': 'context',
    'ALL': 'all',
    'TRIPLE_TERM': 'triple-term',
};
